/* import __COLOCATED_TEMPLATE__ from './add-contact-modal.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import styles from './add-contact-modal.module.scss';

const REMINDER_PREFERENCES = {
  0: '',
  1: 'phoneLeaveVoiceMessage',
  2: 'phoneLeaveTextMessage',
};

export default class SiteDocumentsContactInfoContactsListSectionAddContactModal extends Component {
  styles = styles;

  get showPhoneReminderOptions() {
    return this.args.practiceEnableSmsReminders || this.args.practiceEnableVoiceReminders;
  }

  @action
  setReminderPreference(attrName, consentAttrName, value) {
    this.args.newContact.set(attrName, value);

    if (value && consentAttrName) {
      this.args.newContact.set(consentAttrName, true);
    }
  }

  @action
  setNewContactAttribute(key, value) {
    this.args.newContact.set(key, value ?? '');
  }

  @action
  setNewContactBoolean(key, { checked }) {
    this.args.newContact.set(key, checked);
  }

  @action
  onReminderPreferenceRadio({ value }) {
    if (value === undefined || value === null) return;

    const num = Number(value);
    const consentAttrName = REMINDER_PREFERENCES[num];

    if (num === 0) {
      this.args.newContact.set('phoneLeaveVoiceMessage', false);
      this.args.newContact.set('phoneLeaveTextMessage', false);
    }

    if (consentAttrName !== undefined) {
      this.setReminderPreference('enableSmsvoiceReminders', consentAttrName, num);
    }
  }
}
